export const reportsStepTests = {
    namespaced: true,

    state: {
        filter: {
            athletes: [],
            gender: '',
            full_name: '',
            tags: [],
            focuses: []
        }
    },

    getters: {
        stepTestFilter(state) {
            return state.filter;
        }
    },

    mutations: {
        resetFilter(state) {
            state.filter = {
                athletes: [],
                gender: '',
                full_name: '',
                tags: [],
                focuses: []
            };
        },

        setFilter(state, filter) {
            state.filter = filter;
        },

        setAthletes(state, athletes) {
            state.filter.athletes = athletes;
        },

        setTags(state, tags) {
            state.filter.tags = tags;
        },

        setFocuses(state, focuses) {
            state.filter.focuses = focuses;
        }
    }
};

export default reportsStepTests;
